export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {

        background: {
          default: "#fff",
          paper: "#fff",
          menu: "#05556F"
        },
        text: {
          menu:"#fff",
          primary: "#080808",
        },
      }
      : {

        background: {
          default: "#181d1f",
          paper: "#202527",
          menu: "#031c25",
        },
        text: {
          menu:"#fff",
          primary: "#fff",

        },
      }),
  },
});